module.exports = __webpack_public_path__ + "img/floorplan.a9c863d0.svg";